import api from "./api";

const VIDEO_BASE = "/video";

export const getVideoSettings = (cameraId) =>
  api.get(`${VIDEO_BASE}/cameras/${cameraId}/video-settings`).then((response) => response.data);

export const saveVideoSettings = (cameraId, payload) =>
  api.put(`${VIDEO_BASE}/admin/cameras/${cameraId}/video-settings`, payload).then((response) => response.data);

export const updateArchiveTimezone = (cameraId, archiveTimezone) =>
  api.patch(`${VIDEO_BASE}/admin/cameras/${cameraId}/archive-timezone`, {
    archive_timezone: archiveTimezone,
  }).then((response) => response.data);

export const startLive = (cameraId) =>
  api.post(`${VIDEO_BASE}/cameras/${cameraId}/live/start`).then((response) => response.data);

export const warmupLive = (cameraId) =>
  api.post(`${VIDEO_BASE}/cameras/${cameraId}/live/warmup`).then((response) => response.data);

export const stopLive = (cameraId) =>
  api.post(`${VIDEO_BASE}/cameras/${cameraId}/live/stop`).then((response) => response.data);

export const startArchive = (cameraId) =>
  api.post(`${VIDEO_BASE}/cameras/${cameraId}/archive/start`).then((response) => response.data);

export const stopArchive = (cameraId) =>
  api.post(`${VIDEO_BASE}/cameras/${cameraId}/archive/stop`).then((response) => response.data);

export const listArchiveRange = (cameraId, params = {}) =>
  api.get(`${VIDEO_BASE}/cameras/${cameraId}/archive/range`, { params }).then((response) => response.data);

export const getArchiveSegmentUrl = (cameraId, segmentRef, expiresSeconds = 600) =>
  api
    .get(`${VIDEO_BASE}/cameras/${cameraId}/archive/segments/${encodeURIComponent(segmentRef)}/url`, {
      params: { expires_seconds: expiresSeconds },
    })
    .then((response) => response.data);
